import { render, staticRenderFns } from "./Quize_bank.vue?vue&type=template&id=3f710a62&scoped=true"
import script from "./Quize_bank.vue?vue&type=script&lang=js"
export * from "./Quize_bank.vue?vue&type=script&lang=js"
import style0 from "./Quize_bank.vue?vue&type=style&index=0&id=3f710a62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f710a62",
  null
  
)

export default component.exports